// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ticket-chat-page {
  max-width: 440px;
  margin: 0 auto;
  padding: 0;
  box-sizing: border-box;
  height: 100vh;
  height: var(--ticket-chat-viewport-height, 100dvh);
  min-height: 100vh;
  min-height: var(--ticket-chat-viewport-height, 100dvh);
  background: #f7f9fa;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.ticket-chat-header {
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 20;
  border-radius: 0 0 22px 22px;
  box-shadow: 0 6px 24px 0 rgba(36, 41, 57, 0.08);
  margin-bottom: 7px;
}

.ticket-chat-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 9px 18px 0 18px;
  min-height: 49px;
  gap: 10px;
}

.ticket-chat-title {
  font-size: 1.09rem;
  font-weight: 700;
  color: #232137;
  line-height: 1.17;
  flex: 1 1;
}

.ticket-chat-status {
  font-size: 0.98rem;
  font-weight: 600;
  padding: 3px 13px 3px 10px;
  border-radius: 12px;
  color: #fff;
  background: #e72f44;
  min-width: 72px;
  text-align: center;
  letter-spacing: 0.01em;
}

.status-waiting {
  background: #ffe066;
  color: #232137;
}

.status-closed {
  background: #bfc2d1;
  color: #fff;
}

.ticket-chat-rating {
  display: grid;
  gap: 9px;
  margin: 0 8px 8px 8px;
  padding: 10px 12px;
  border: 1px solid #ffd7a3;
  border-radius: 16px;
  background: #fff8ed;
  box-shadow: 0 2px 12px 0 rgba(36, 41, 57, 0.05);
}

.ticket-chat-rating-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.ticket-chat-rating-title span,
.ticket-chat-rating-note {
  color: #8a5200;
  font-size: 0.88rem;
  line-height: 1.25;
}

.ticket-chat-rating-title strong {
  color: #5d3700;
  white-space: nowrap;
}

.ticket-chat-rating-buttons {
  display: grid;
  grid-template-columns: repeat(5, minmax(38px, 1fr));
  gap: 7px;
}

.ticket-chat-rating-buttons button {
  min-height: 38px;
  border: 1px solid #f3a329;
  border-radius: 12px;
  background: #fff;
  color: #8a5200;
  font-weight: 800;
}

.ticket-chat-rating-buttons button.active,
.ticket-chat-rating-buttons button:active {
  background: #f3a329;
  color: #fff;
}

.ticket-chat-rating-buttons button:disabled {
  opacity: 0.62;
}

.ticket-chat-rating-comment {
  width: 100%;
  min-height: 76px;
  resize: vertical;
  border: 1px solid #ffd7a3;
  border-radius: 10px;
  padding: 9px 10px;
  background: #fff;
  color: #332616;
  font: inherit;
}

.ticket-chat-rating-comment:disabled {
  opacity: 0.7;
}

.ticket-chat-rating-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.ticket-chat-rating-footer span {
  color: #8a5200;
  font-size: 0.78rem;
}

.ticket-chat-rating-submit {
  min-height: 36px;
  border: 0;
  border-radius: 10px;
  padding: 0 14px;
  background: #f3a329;
  color: #fff;
  font-weight: 800;
}

.ticket-chat-rating-submit:disabled {
  opacity: 0.62;
}

.ticket-chat-rating-readonly {
  margin: 0;
  padding: 9px 10px;
  border-radius: 10px;
  background: #fff;
  color: #4f3a1d;
  white-space: pre-wrap;
}

.ticket-chat-messages {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: 0 7px 18px 7px;
  display: flex;
  flex-direction: column;
  gap: 9px;
  scroll-padding-bottom: 96px;
}

.ticket-chat-message {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: 96%;
}

.ticket-chat-message.user {
  align-items: flex-end;
}

.message-bubble {
  background: #fff;
  color: #232137;
  font-size: 1.05rem;
  padding: 11px 14px;
  border-radius: 17px 17px 6px 17px;
  box-shadow: 0 2px 12px 0 rgba(36, 41, 57, 0.06);
  max-width: 86vw;
  word-break: break-word;
  margin-bottom: 4px;
  white-space: pre-line;
}

.ticket-chat-message.user .message-bubble {
  background: linear-gradient(93deg, #f8e1ea 7%, #ffe6ef 94%);
  color: #e72f44;
  border-radius: 17px 17px 17px 7px;
}

.message-date {
  font-size: 0.89rem;
  color: #bfc2d1;
  margin-left: 7px;
  margin-right: 7px;
}

.ticket-chat-message.user .message-date {
  color: #e7b5be;
}

.message-attachments {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
  margin: -2px 0 2px 0;
}

@media (min-width: 420px) {
  .message-attachments {
    grid-template-columns: repeat(2, 1fr);
  }
}
.message-attach {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.message-attach-thumb-wrap {
  display: block;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 2px 12px 0 rgba(36, 41, 57, 0.06);
  border: 1px solid #eef0f6;
  background: #fff;
}

.message-attach-thumb {
  width: 100%;
  height: 190px;
  object-fit: cover;
  display: block;
  background: #f3f5f8;
}

.message-attach-link-only {
  margin-top: 6px;
}

.message-attach-link-only a {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #e72f44;
  font-weight: 600;
  text-decoration: none;
  padding: 6px 8px;
  border-radius: 10px;
}

.message-attach-link-only a:hover {
  text-decoration: underline;
  text-underline-offset: 2px;
}

.ticket-chat-message .message-attach-link-only--file a {
  background: #fff;
  border: 1px solid #eef0f6;
  box-shadow: 0 2px 12px 0 rgba(36, 41, 57, 0.06);
  color: #232137;
}

.ticket-chat-message .message-attach-link-only--file a:hover {
  color: #e72f44;
  border-color: #ffd4e2;
}

.ticket-chat-input-row {
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 9px 10px 10px 10px;
  background: #fff;
  border: 1px solid #ededf5;
  border-radius: 20px;
  box-shadow: 0 -1px 14px 0 rgba(36, 41, 57, 0.08);
  position: relative;
  z-index: 30;
  margin: 0 8px calc(8px + env(safe-area-inset-bottom, 0px)) 8px;
  gap: 8px;
}

.ticket-chat-compose-line {
  display: flex;
  align-items: flex-end;
  gap: 9px;
}

.ticket-chat-input {
  flex: 1 1;
  min-width: 0;
  min-height: 44px;
  max-height: 92px;
  font-size: 1rem;
  line-height: 1.25;
  border-radius: 14px;
  border: 1px solid #e0e2ef;
  padding: 11px 12px;
  outline: none;
  transition: border 0.14s;
  font-family: "Cera Pro", Arial, sans-serif;
  color: #232137;
  background: #f7f9fa;
  resize: none;
  overflow-y: auto;
  box-sizing: border-box;
}

.ticket-chat-input:focus {
  border: 1.5px solid #e72f44;
  background: #fff;
}

.ticket-chat-send-btn {
  background: #e72f44;
  color: #fff;
  min-width: 92px;
  height: 44px;
  font-size: 0.95rem;
  font-weight: 700;
  border: none;
  border-radius: 11px;
  padding: 0 12px;
  cursor: pointer;
  transition: background 0.13s;
}

.ticket-chat-send-btn:active,
.ticket-chat-send-btn:disabled {
  background: #d4a3af;
}

.ticket-chat-attach-btn {
  width: 44px;
  height: 44px;
  flex: 0 0 44px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e0e2ef;
  border-radius: 13px;
  background: #f7f9fa;
  color: #e72f44;
  font-size: 1.45rem;
  font-weight: 700;
  line-height: 1;
  cursor: pointer;
}

@media (max-width: 480px) {
  .ticket-chat-input-row {
    margin-bottom: calc(12px + max(env(safe-area-inset-bottom, 0px), 18px));
  }
}
.ticket-chat-attach-btn:disabled {
  color: #d4a3af;
  cursor: default;
}

.ticket-chat-selected-files {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.ticket-chat-selected-file {
  max-width: 100%;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 6px 8px;
  border-radius: 10px;
  background: #fff4f7;
  border: 1px solid #ffd4e2;
  color: #232137;
  font-size: 0.86rem;
}

.ticket-chat-selected-file span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ticket-chat-selected-file button {
  width: 22px;
  height: 22px;
  border: none;
  border-radius: 50%;
  background: #fff;
  color: #e72f44;
  font-weight: 700;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/pages/TicketChatPage/ticketChat.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,cAAA;EACA,UAAA;EACA,sBAAA;EACA,aAAA;EACA,kDAAA;EACA,iBAAA;EACA,sDAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AACF;;AAEA;EACE,gBAAA;EACA,MAAA;EACA,gBAAA;EACA,WAAA;EACA,4BAAA;EACA,+CAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,wBAAA;EACA,gBAAA;EACA,SAAA;AACF;;AAEA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,SAAA;AACF;;AAEA;EACE,kBAAA;EACA,gBAAA;EACA,0BAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;AACF;;AACA;EAAkB,mBAAA;EAAqB,cAAA;AAIvC;;AAHA;EAAiB,mBAAA;EAAqB,WAAA;AAQtC;;AANA;EACE,aAAA;EACA,QAAA;EACA,qBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,+CAAA;AASF;;AANA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AASF;;AANA;;EAEE,cAAA;EACA,kBAAA;EACA,iBAAA;AASF;;AANA;EACE,cAAA;EACA,mBAAA;AASF;;AANA;EACE,aAAA;EACA,mDAAA;EACA,QAAA;AASF;;AANA;EACE,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AASF;;AANA;;EAEE,mBAAA;EACA,WAAA;AASF;;AANA;EACE,aAAA;AASF;;AANA;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;AASF;;AANA;EACE,YAAA;AASF;;AANA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AASF;;AANA;EACE,cAAA;EACA,kBAAA;AASF;;AANA;EACE,gBAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;AASF;;AANA;EACE,aAAA;AASF;;AANA;EACE,SAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;AASF;;AANA;EACE,cAAA;EACA,aAAA;EACA,gBAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,2BAAA;AASF;;AANA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,cAAA;AASF;;AANA;EACE,qBAAA;AASF;;AANA;EACE,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,iCAAA;EACA,+CAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,qBAAA;AASF;;AANA;EACE,2DAAA;EACA,cAAA;EACA,iCAAA;AASF;;AANA;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;AASF;;AANA;EACE,cAAA;AASF;;AANA;EACE,WAAA;EACA,aAAA;EACA,0BAAA;EACA,QAAA;EACA,oBAAA;AASF;;AANA;EACE;IACE,qCAAA;EASF;AACF;AANA;EACE,aAAA;EACA,sBAAA;EACA,oBAAA;AAQF;;AALA;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,+CAAA;EACA,yBAAA;EACA,gBAAA;AAQF;;AALA;EACE,WAAA;EACA,aAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AAQF;;AALA;EACE,eAAA;AAQF;;AALA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,gBAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;AAQF;;AALA;EACE,0BAAA;EACA,0BAAA;AAQF;;AALA;EACE,gBAAA;EACA,yBAAA;EACA,+CAAA;EACA,cAAA;AAQF;;AALA;EACE,cAAA;EACA,qBAAA;AAQF;;AALA;EACE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,2BAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gDAAA;EACA,kBAAA;EACA,WAAA;EACA,8DAAA;EACA,QAAA;AAQF;;AALA;EACE,aAAA;EACA,qBAAA;EACA,QAAA;AAQF;;AALA;EACE,SAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,wBAAA;EACA,0CAAA;EACA,cAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;AAQF;;AALA;EACE,2BAAA;EACA,gBAAA;AAQF;;AALA;EACE,mBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,4BAAA;AAQF;;AANA;;EAEE,mBAAA;AASF;;AANA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AASF;;AANA;EACE;IACE,uEAAA;EASF;AACF;AANA;EACE,cAAA;EACA,eAAA;AAQF;;AALA;EACE,aAAA;EACA,eAAA;EACA,QAAA;AAQF;;AALA;EACE,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;AAQF;;AALA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AAQF;;AALA;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AAQF","sourcesContent":[".ticket-chat-page {\n  max-width: 440px;\n  margin: 0 auto;\n  padding: 0;\n  box-sizing: border-box;\n  height: 100vh;\n  height: var(--ticket-chat-viewport-height, 100dvh);\n  min-height: 100vh;\n  min-height: var(--ticket-chat-viewport-height, 100dvh);\n  background: #f7f9fa;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\r\n.ticket-chat-header {\r\n  position: sticky;\r\n  top: 0;\r\n  background: #fff;\r\n  z-index: 20;\r\n  border-radius: 0 0 22px 22px;\r\n  box-shadow: 0 6px 24px 0 rgba(36,41,57,0.08);\r\n  margin-bottom: 7px;\r\n}\r\n\r\n.ticket-chat-title-row {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 9px 18px 0 18px;\r\n  min-height: 49px;\r\n  gap: 10px;\r\n}\r\n\r\n.ticket-chat-title {\r\n  font-size: 1.09rem;\r\n  font-weight: 700;\r\n  color: #232137;\r\n  line-height: 1.17;\r\n  flex: 1;\r\n}\r\n\r\n.ticket-chat-status {\r\n  font-size: 0.98rem;\r\n  font-weight: 600;\r\n  padding: 3px 13px 3px 10px;\r\n  border-radius: 12px;\r\n  color: #fff;\r\n  background: #e72f44;\r\n  min-width: 72px;\r\n  text-align: center;\r\n  letter-spacing: 0.01em;\r\n}\r\n.status-waiting { background: #ffe066; color: #232137; }\n.status-closed { background: #bfc2d1; color: #fff; }\n\n.ticket-chat-rating {\n  display: grid;\n  gap: 9px;\n  margin: 0 8px 8px 8px;\n  padding: 10px 12px;\n  border: 1px solid #ffd7a3;\n  border-radius: 16px;\n  background: #fff8ed;\n  box-shadow: 0 2px 12px 0 rgba(36,41,57,0.05);\n}\n\n.ticket-chat-rating-title {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.ticket-chat-rating-title span,\n.ticket-chat-rating-note {\n  color: #8a5200;\n  font-size: .88rem;\n  line-height: 1.25;\n}\n\n.ticket-chat-rating-title strong {\n  color: #5d3700;\n  white-space: nowrap;\n}\n\n.ticket-chat-rating-buttons {\n  display: grid;\n  grid-template-columns: repeat(5, minmax(38px, 1fr));\n  gap: 7px;\n}\n\n.ticket-chat-rating-buttons button {\n  min-height: 38px;\n  border: 1px solid #f3a329;\n  border-radius: 12px;\n  background: #fff;\n  color: #8a5200;\n  font-weight: 800;\n}\n\n.ticket-chat-rating-buttons button.active,\n.ticket-chat-rating-buttons button:active {\n  background: #f3a329;\n  color: #fff;\n}\n\n.ticket-chat-rating-buttons button:disabled {\n  opacity: .62;\n}\n\n.ticket-chat-rating-comment {\n  width: 100%;\n  min-height: 76px;\n  resize: vertical;\n  border: 1px solid #ffd7a3;\n  border-radius: 10px;\n  padding: 9px 10px;\n  background: #fff;\n  color: #332616;\n  font: inherit;\n}\n\n.ticket-chat-rating-comment:disabled {\n  opacity: .7;\n}\n\n.ticket-chat-rating-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.ticket-chat-rating-footer span {\n  color: #8a5200;\n  font-size: .78rem;\n}\n\n.ticket-chat-rating-submit {\n  min-height: 36px;\n  border: 0;\n  border-radius: 10px;\n  padding: 0 14px;\n  background: #f3a329;\n  color: #fff;\n  font-weight: 800;\n}\n\n.ticket-chat-rating-submit:disabled {\n  opacity: .62;\n}\n\n.ticket-chat-rating-readonly {\n  margin: 0;\n  padding: 9px 10px;\n  border-radius: 10px;\n  background: #fff;\n  color: #4f3a1d;\n  white-space: pre-wrap;\n}\n\n.ticket-chat-messages {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 0 7px 18px 7px;\n  display: flex;\n  flex-direction: column;\n  gap: 9px;\n  scroll-padding-bottom: 96px;\n}\n\r\n.ticket-chat-message {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  max-width: 96%;\r\n}\r\n\r\n.ticket-chat-message.user {\r\n  align-items: flex-end;\r\n}\r\n\r\n.message-bubble {\r\n  background: #fff;\r\n  color: #232137;\r\n  font-size: 1.05rem;\r\n  padding: 11px 14px;\r\n  border-radius: 17px 17px 6px 17px;\r\n  box-shadow: 0 2px 12px 0 rgba(36,41,57,0.06);\r\n  max-width: 86vw;\r\n  word-break: break-word;\r\n  margin-bottom: 4px;\r\n  white-space: pre-line;\r\n}\r\n\r\n.ticket-chat-message.user .message-bubble {\r\n  background: linear-gradient(93deg, #f8e1ea 7%, #ffe6ef 94%);\r\n  color: #e72f44;\r\n  border-radius: 17px 17px 17px 7px;\r\n}\r\n\r\n.message-date {\r\n  font-size: 0.89rem;\r\n  color: #bfc2d1;\r\n  margin-left: 7px;\r\n  margin-right: 7px;\r\n}\r\n\r\n.ticket-chat-message.user .message-date {\n  color: #e7b5be;\n}\n\n.message-attachments {\n  width: 100%;\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 8px;\n  margin: -2px 0 2px 0;\n}\n\n@media (min-width: 420px) {\n  .message-attachments {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n.message-attach {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n}\n\n.message-attach-thumb-wrap {\n  display: block;\n  border-radius: 14px;\n  overflow: hidden;\n  box-shadow: 0 2px 12px 0 rgba(36,41,57,0.06);\n  border: 1px solid #eef0f6;\n  background: #fff;\n}\n\n.message-attach-thumb {\n  width: 100%;\n  height: 190px;\n  object-fit: cover;\n  display: block;\n  background: #f3f5f8;\n}\n\n.message-attach-link-only {\n  margin-top: 6px;\n}\n\n.message-attach-link-only a {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  color: #e72f44;\n  font-weight: 600;\n  text-decoration: none;\n  padding: 6px 8px;\n  border-radius: 10px;\n}\n\n.message-attach-link-only a:hover {\n  text-decoration: underline;\n  text-underline-offset: 2px;\n}\n\n.ticket-chat-message .message-attach-link-only--file a {\n  background: #fff;\n  border: 1px solid #eef0f6;\n  box-shadow: 0 2px 12px 0 rgba(36,41,57,0.06);\n  color: #232137;\n}\n\n.ticket-chat-message .message-attach-link-only--file a:hover {\n  color: #e72f44;\n  border-color: #ffd4e2;\n}\n\n.ticket-chat-input-row {\n  flex: 0 0 auto;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  padding: 9px 10px 10px 10px;\n  background: #fff;\n  border: 1px solid #ededf5;\n  border-radius: 20px;\n  box-shadow: 0 -1px 14px 0 rgba(36,41,57,0.08);\n  position: relative;\n  z-index: 30;\n  margin: 0 8px calc(8px + env(safe-area-inset-bottom, 0px)) 8px;\n  gap: 8px;\n}\n\n.ticket-chat-compose-line {\n  display: flex;\n  align-items: flex-end;\n  gap: 9px;\n}\n\n.ticket-chat-input {\n  flex: 1;\n  min-width: 0;\n  min-height: 44px;\n  max-height: 92px;\n  font-size: 1rem;\n  line-height: 1.25;\n  border-radius: 14px;\n  border: 1px solid #e0e2ef;\n  padding: 11px 12px;\n  outline: none;\n  transition: border .14s;\n  font-family: 'Cera Pro', Arial, sans-serif;\n  color: #232137;\n  background: #f7f9fa;\n  resize: none;\n  overflow-y: auto;\n  box-sizing: border-box;\n}\n\r\n.ticket-chat-input:focus {\r\n  border: 1.5px solid #e72f44;\r\n  background: #fff;\r\n}\r\n\r\n.ticket-chat-send-btn {\n  background: #e72f44;\n  color: #fff;\n  min-width: 92px;\n  height: 44px;\n  font-size: 0.95rem;\n  font-weight: 700;\n  border: none;\n  border-radius: 11px;\n  padding: 0 12px;\n  cursor: pointer;\n  transition: background .13s;\n}\n.ticket-chat-send-btn:active,\n.ticket-chat-send-btn:disabled {\n  background: #d4a3af;\n}\n\n.ticket-chat-attach-btn {\n  width: 44px;\n  height: 44px;\n  flex: 0 0 44px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #e0e2ef;\n  border-radius: 13px;\n  background: #f7f9fa;\n  color: #e72f44;\n  font-size: 1.45rem;\n  font-weight: 700;\n  line-height: 1;\n  cursor: pointer;\n}\n\n@media (max-width: 480px) {\n  .ticket-chat-input-row {\n    margin-bottom: calc(12px + max(env(safe-area-inset-bottom, 0px), 18px));\n  }\n}\n\n.ticket-chat-attach-btn:disabled {\n  color: #d4a3af;\n  cursor: default;\n}\n\n.ticket-chat-selected-files {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.ticket-chat-selected-file {\n  max-width: 100%;\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  padding: 6px 8px;\n  border-radius: 10px;\n  background: #fff4f7;\n  border: 1px solid #ffd4e2;\n  color: #232137;\n  font-size: 0.86rem;\n}\n\n.ticket-chat-selected-file span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.ticket-chat-selected-file button {\n  width: 22px;\n  height: 22px;\n  border: none;\n  border-radius: 50%;\n  background: #fff;\n  color: #e72f44;\n  font-weight: 700;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
